// extracted by mini-css-extract-plugin
export default {"button":"BanButton_button__nQrvI"};